import { proStudioUrqlGql as urqlGql } from '@pypestream/api-services';

import { checkForErrors } from './check-for-errors';

/**
 * The environment names a solution is published to (lowercased, e.g.
 * `['sandbox', 'live']`) — every environment with a `finished` deployment. Returns `[]`
 * when it is published nowhere.
 *
 * Read from the Agent Manager deployment rows. It used to come from Bot Manager's
 * `getEnvBotVersions`, which answers "Bot does not exist." for every solution created
 * after the migration, so no v2 main was ever linkable from a survey's publish modal.
 */
export const getBotPublishedEnvs = async ({
  solutionId,
}: {
  solutionId: string;
}): Promise<string[]> => {
  const response = await urqlGql.getSolutionPublishedEnvironments({
    solutionId,
  });

  checkForErrors(response);

  return [
    ...new Set(
      (response.data?.tenancy_solution_deployments ?? [])
        .map((row) => String(row?.environment ?? '').toLowerCase())
        .filter(Boolean)
    ),
  ];
};
